require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2008-11-01-i-love-my-iphone.json") })
        }
      }, "path---articles-2008-11-01-i-love-my-iphone");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2008-11-01-i-love-my-iphone!./.cache/json/articles-2008-11-01-i-love-my-iphone.json
// module id = 553
// module chunks = 231608221292675